import { colors } from '../../colors'

interface BackButtonProps {
  href?: string
  children: React.ReactNode
  variant?: 'default' | 'primary'
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
}

const styles: Record<string, React.CSSProperties> = {
  backLink: {
    flex: '1',
  },
  backButton: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    fontSize: '14px',
    height: '48px',
    padding: '0 24px',
    borderRadius: '9999px',
    fontWeight: '600',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
  },
  default: {
    color: colors['keijiban-coral'],
    border: `1px solid ${colors['keijiban-coral']}`,
    backgroundColor: colors.white,
  },
  primary: {
    color: colors.white,
    backgroundColor: colors['keijiban-coral'],
    border: 'none',
  },
}

const BackButton: React.FC<BackButtonProps> = ({
  href,
  children,
  variant = 'default',
  className,
  style,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div style={styles.backLink} className={className}>
      <a
        href={href || '#'}
        onClick={onClick ? handleClick : undefined}
        style={{
          ...styles.backButton,
          ...styles[variant],
          ...(onClick && !href ? { cursor: 'pointer' } : {}),
          ...style,
        }}
      >
        {children}
      </a>
    </div>
  )
}

export default BackButton
